export const CONSTANTS =  {
    OrderSessionTokenKey: '__orderSessionToken', // Local Storage Key 
    Order_TTL : 10, // tiempo de vigencia de la orden  en minutos
    //discount types
    TICKETS_PORCENTAGE_DISCOUNT_TYPOLOGY: 160750,
    ORDER_AMOUNT_DISCOUNT_TYPOLOGY: 160751,
    ORDER_TOTAL_OVERRIDE_DISCOUNT_TYPOLOGY: 160752,


    /// tikcets custom Rules Flags
    FIRST_TICKET_FULL_PRICE_NEXT_WITH_SPECIFIC_DISCOUNT: 'first_ticket_full_price_next_with_specific_discount',
    LAST_TICKET_FREE_ABOVE_X_NUMBER_OF_TICKETS: 'last_ticket_free_above_x_number_of_tickets',
    BULK_QUANTITY_TIER_DISCOUNT: 'bulk_quantity_tier_discount',


    /// bokings status typologies

    BOOKED_TICKET_UNPAID_STATUS: 160910,
    BOOKED_TICKET_PAID_STATUS: 160909,
    BOOKING_STATUS_PARTIALLY_PAID: 160911,
    BOOKING_STATUS_EXPIRED: 160913,

    //
    FREE_SINGLE_REGISTRATION_TICKET_TYPE: 160919,
    TYPOLOGY_ID_SETTING_SHOP_GROUP_PURCHASES: 160920,
    SETTING_ID_POST_REGISTER_FLOW: 160920,
    SETTING_ID_WHATSAPP_DELIVERY_METHOD: 160939,

    // categoría Proticket por defecto de un ticket ("SIN CATEGORIA"): no corresponde a ningún área GA del mapa
    DEFAULT_TICKET_CATEGORY_TYPOLOGY: 160936,
    
}
